import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowRoundClockwise16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowRoundClockwise16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.217 6.85c-.634-2.367-2.951-3.697-5.32-3.062-2.367.634-3.708 2.958-3.074 5.327s2.959 3.71 5.326 3.076a4.45 4.45 0 0 0 1.73-.892 3.6 3.6 0 0 0 .495-.508l.019-.026.002-.004v.001-.001a.5.5 0 0 1 .831.557l-.395-.264.395.264-.001.001-.001.002-.004.006-.01.015a3 3 0 0 1-.17.214 4.6 4.6 0 0 1-.514.507 5.45 5.45 0 0 1-2.118 1.095c-2.901.777-5.773-.882-6.55-3.784s.88-5.775 3.78-6.552c2.706-.725 5.385.657 6.362 3.205V3.934a.5.5 0 0 1 1 0v4h-4a.5.5 0 0 1 0-1h2.248l-.03-.084"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowRoundClockwise16);
